// Copyright 2020 Sorama B.V.

import { computedFrom } from "aurelia-framework";
import { CanvasMediaObjectLinkDTO, TwoDimensionalLinkedMediaObjectDTO } from "datatypes/SoramaWebApi";
import { ICanvasMediaObjectLinkRepository } from "repositories/CanvasMediaObjectLinkRepository";
import { BoundingBox, IComposableParent } from "../ComposableCanvas";
import { ComposableContentType, ComposableMediaObject } from "./ComposableMediaObject";

export abstract class ComposableTwoDimensionalMediaObject extends ComposableMediaObject {
    public readonly preserveAspectRatio: boolean = true;
    public readonly contentType: ComposableContentType = ComposableContentType.scaled;

    @computedFrom("twoDimensionalMediaObject", "canvasSize")
    protected get scaleX(): number {
        return (
            this.canvasSize.width /
            this.canvasSize.height /
            (this.twoDimensionalMediaObject.dimension.width / this.twoDimensionalMediaObject.dimension.height)
        );
    }

    protected get fontSize(): number {
        return this.canvasSize.height / 10;
    }

    constructor(
        linkRepository: ICanvasMediaObjectLinkRepository,
        parent: IComposableParent,
        link: CanvasMediaObjectLinkDTO,
        initialSize: BoundingBox,
        private readonly twoDimensionalMediaObject: TwoDimensionalLinkedMediaObjectDTO
    ) {
        super(linkRepository, parent, link, initialSize);
    }
}
